/*
 * Płynne przejście między produktami z rodziny Ergonode (picker w snippets/ergonode-variant-picker.liquid).
 *
 * Link pickera to zwykłe wejście na stronę innego produktu, więc GA4, Meta i piksele Shopify
 * liczą je jak każde inne. Ten skrypt:
 * - przy kliknięciu zapisuje, gdzie na ekranie był picker; nowa strona odtwarza to miejsce
 *   (snippets/ergonode-switch-head.liquid),
 * - dodaje typ view transition „ergonode-switch” do przejścia ze strony,
 * - po najechaniu, dotknięciu lub fokusie wczytuje główne zdjęcie produktu docelowego
 *   w tych samych rozmiarach co galeria, żeby po przejściu nie było pustego miejsca.
 */
(() => {
  if (window.ergonodeSwitch) return;
  window.ergonodeSwitch = true;

  const STORAGE_KEY = 'ergonode-switch';
  const LINK_SELECTOR = 'a[data-ev-link]';
  const PENDING_CLASS = 'ergonode-switch-pending';
  let pendingUrl = null;
  let pendingTimer = null;

  const isPlainClick = (event) =>
    event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

  /**
   * Natychmiastowa odpowiedź na kliknięcie, zanim przyjdzie strona produktu:
   * zaznaczamy wybraną wartość, zmieniamy podpis osi i lekko przygaszamy galerię.
   * Przy wolnym łączu klient widzi, że kliknięcie zadziałało, i nie klika drugi raz.
   */
  let restorePending = null;
  const showPending = (link, anchor) => {
    restorePending?.();
    const previous = [...anchor.querySelectorAll('.active, .is-active')].map((item) => [item, item.className]);
    const label = anchor.previousElementSibling?.querySelector('span');
    const previousLabel = label?.textContent;
    const linkClass = link.className;

    previous.forEach(([item]) => item.classList.remove('active', 'is-active'));
    link.classList.add(link.classList.contains('ergonode-variant__pill') ? 'is-active' : 'active');
    if (label && link.dataset.evValue) label.textContent = link.dataset.evValue;
    document.documentElement.classList.add(PENDING_CLASS);

    restorePending = () => {
      previous.forEach(([item, className]) => (item.className = className));
      link.className = linkClass;
      if (label) label.textContent = previousLabel;
      document.documentElement.classList.remove(PENDING_CLASS);
      clearTimeout(pendingTimer);
      pendingUrl = null;
      restorePending = null;
    };
    clearTimeout(pendingTimer);
    // Przerwane wczytywanie (Esc, błąd sieci): po chwili wracamy do zwykłego wyglądu.
    pendingTimer = setTimeout(() => restorePending?.(), 8000);
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest(LINK_SELECTOR) : null;
    if (!link || !isPlainClick(event) || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    const anchor = link.closest('[data-ergonode-switch-anchor]');
    if (!anchor) return;
    // Drugie kliknięcie w ten sam link nie zaczyna wczytywania od nowa.
    if (pendingUrl === url.pathname + url.search) {
      event.preventDefault();
      return;
    }
    showPending(link, anchor);
    pendingUrl = url.pathname + url.search;
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          to: pendingUrl,
          at: Date.now(),
          axis: anchor.dataset.ergonodeSwitchAnchor,
          offset: anchor.getBoundingClientRect().top,
          scrollY: window.scrollY,
        })
      );
    } catch (error) {
      // Bez sessionStorage przejście działa jak zwykły link.
    }
  });

  window.addEventListener('pageswap', (event) => {
    if (!event.viewTransition || !pendingUrl || !event.activation?.entry?.url) return;
    const target = new URL(event.activation.entry.url);
    if (target.pathname + target.search === pendingUrl) event.viewTransition.types.add('ergonode-switch');
  });

  // Wraca z bfcache: stary zapis nie może przewinąć innej strony, a strona ma wyglądać jak przed kliknięciem.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) restorePending?.();
  });

  const preloaded = new Set();
  const preloadImage = (link) => {
    const base = link.dataset.evImage;
    if (!base || preloaded.has(base)) return;
    const galleryImage = document.querySelector('.product-media__image[srcset]');
    if (!galleryImage) return;
    preloaded.add(base);
    const separator = base.includes('?') ? '&' : '?';
    const srcset = galleryImage
      .getAttribute('srcset')
      .split(',')
      .map((candidate) => candidate.trim().split(/\s+/)[1])
      .filter((descriptor) => descriptor && descriptor.endsWith('w'))
      .map((descriptor) => `${base}${separator}width=${parseInt(descriptor, 10)} ${descriptor}`)
      .join(', ');
    if (!srcset) return;
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.setAttribute('imagesrcset', srcset);
    preload.setAttribute('imagesizes', galleryImage.getAttribute('sizes') || '100vw');
    document.head.appendChild(preload);
  };

  const onIntent = (event) => {
    const link = event.target instanceof Element ? event.target.closest(LINK_SELECTOR) : null;
    if (link) preloadImage(link);
  };
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('pointerdown', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
})();
